unit GetStammdaten;

interface

uses System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WebBasis2,
     WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, VCL.TMSFNCTypes,
     VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl,
     VCL.TMSFNCToolBar, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Grids,
     Vcl.Grids, WEBLib.DBCtrls, XData.Web.Client, Bcl.Utils, CP.Func.AES, Vcl.Imaging.GIFImg, VCL.TMSFNCListBox,
     VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer ;

     [async] Procedure Get_Stammdaten(  var aTab, aID : Integer; var sBez : String ); async;
     [async] Function Get_Stammdaten2(  var aTab, aID : Integer; var sBez : String ) : TModalResult; async;
     [async] Function Get_Fahrzeug(  var aID : Integer; var sBez : String; iEigenAntrieb : Integer ) : TModalResult; async;
type
  TfrmGetStammdaten = class(TfrmWebBasis2)
    WebPanel1: TPanel;
    lbSelTabelle: TLabel;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    tabZeitmodelle: TXDataWebDataSet;
    dsZeitmodelle: TDataSource;
    tabZeitmodelleWMOD_NUMMER: TStringField;
    tabZeitmodelleWMOD_NAME: TStringField;
    respGrid: TResponsiveGrid;
    btnAbbrechen: TTMSFNCToolBarButton;
    btnFilter: TTMSFNCToolBarButton;
    procedure WebFormShow(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebPanel3Click(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure respGridItemClick(Sender: TObject; Index: Integer);
    procedure btnAbbrechenClick(Sender: TObject);
    //
    [async]  procedure btnFilterClick(Sender: TObject); async;
    //

  private
    bFirst : Boolean;
    iEigenAntrieb : Integer; // 0=alle 1=Ja  2=Nein
    iRec_Von : Integer;
    iRec_Bis : Integer;
    sFilter  : String;
    [async] procedure Daten_Laden( aID : String ); async;
    procedure Form_Anpassen;

  public
    iTabelle : Integer;
    iSel_ID  : Integer;
    sSel_Id  : String;
    sSel_Bez : String;

  protected procedure LoadDFMValues; override; end;

var frmGetStammdaten: TfrmGetStammdaten;

const c_Fzg  = 10;
      c_ZM   = 20;
      c_Teil = 30;

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb;

//====================================================================================================================//
// sBez = Rückgabe des Feldes BEZEICHNUNG o.ä.

Procedure Get_Stammdaten(  var aTab, aID : Integer; var sBez : String );
begin

  frmGetStammdaten :=  TfrmGetStammdaten.Create(Application);

  frmGetStammdaten.iTabelle := aTab;
  frmGetStammdaten.iSel_ID  := aID;
  frmGetStammdaten.sSel_ID  := '';
  frmGetStammdaten.sSel_Bez := sBez;

  frmGetStammdaten.Popup  := True;

  Case aTab Of
    c_Fzg : Begin
             frmGetStammdaten.Caption := 'Fahrzeug wählen ' ;
             frmGetStammdaten.iEigenAntrieb := 1;
            End;
    c_Teil : Begin
             frmGetStammdaten.Caption := 'Artikel wählen ';
            End;

  End;

  await( TfrmGetStammdaten, frmGetStammdaten.Load() );

  Try

    await( TModalResult, frmGetStammdaten.Execute); // excute form and wait for close
//
    If frmGetStammdaten.ModalResult = mrOK then
      Begin
       aID  := frmGetStammdaten.iSel_ID;
       sBez := frmGetStammdaten.sSel_Bez;
//           console.log('mrOK Ja');
      End;
//    Else console.log('mrOK Ne');

  Finally
    frmGetStammdaten.Free;
  End;

end;


//====================================================================================================================//
// sBez = Rückgabe des Feldes BEZEICHNUNG o.ä.

function Get_Stammdaten2(  var aTab, aID : Integer; var sBez : String ) : TModalResult;
begin

  frmGetStammdaten :=  TfrmGetStammdaten.Create(Application);

  frmGetStammdaten.iTabelle := aTab;
  frmGetStammdaten.iSel_ID  := aID;
  frmGetStammdaten.sSel_ID  := '';
  frmGetStammdaten.sSel_Bez := sBez;

  frmGetStammdaten.Popup  := True;

  Case aTab Of
    c_Fzg : Begin
             frmGetStammdaten.Caption := 'Fahrzeug wählen ' ;
             frmGetStammdaten.iEigenAntrieb := 1;
            End;
    c_Teil : Begin
             frmGetStammdaten.Caption := 'Artikel wählen ';
            End;

  End;

  await( TfrmGetStammdaten, frmGetStammdaten.Load() );

  Try

    await( TModalResult, frmGetStammdaten.Execute); // excute form and wait for close
//
    Result := frmGetStammdaten.ModalResult;

    If Result = mrOK then
      Begin
       aID  := frmGetStammdaten.iSel_ID;
       sBez := frmGetStammdaten.sSel_Bez;

      End;

  Finally
    frmGetStammdaten.Free;
  End;

end;


//====================================================================================================================//

function Get_Fahrzeug(  var aID : Integer; var sBez : String; iEigenAntrieb : Integer ) : TModalResult;
begin

  frmGetStammdaten :=  TfrmGetStammdaten.Create(Application);


  frmGetStammdaten.iSel_ID  := aID;
  frmGetStammdaten.sSel_ID  := '';
  frmGetStammdaten.sSel_Bez := sBez;
  frmGetStammdaten.Popup  := True;
  frmGetStammdaten.Caption := 'Fahrzeug wählen ' ;
  frmGetStammdaten.iTabelle := c_Fzg;
  frmGetStammdaten.iEigenAntrieb := iEigenAntrieb;


  await( TfrmGetStammdaten, frmGetStammdaten.Load() );

  Try

    await( TModalResult, frmGetStammdaten.Execute); // excute form and wait for close
//
    Result := frmGetStammdaten.ModalResult;

    If Result = mrOK then
      Begin
       aID  := frmGetStammdaten.iSel_ID;
       sBez := frmGetStammdaten.sSel_Bez;

      End;

  Finally
    frmGetStammdaten.Free;
  End;

end;


//====================================================================================================================//

procedure TfrmGetStammdaten.btnAbbrechenClick(Sender: TObject);
begin
  inherited;

  ModalResult := mrCancel;
  Close

end;

//====================================================================================================================//

procedure TfrmGetStammdaten.btnFilterClick(Sender: TObject);
var Result : TModalResult;
    sWert : String;
begin
  inherited;

  If btnFilter.Tag = 0 then
   Begin
     Result := await(TModalResult, InputMessageDlgAsync('Filter:',mtInformation, [mbOK, mbCancel], sWert, itText));
     If Result = mrOK then
      Begin
        self.sFilter := sWert;
        btnFilter.Tag := 1;
        btnFilter.Text := sFilter;
        btnFilter.Bitmaps[0].BitmapName := 'FILTER_EIN';
        Daten_Laden('0');
      End;

    Exit
   End;


  If btnFilter.Tag = 1 then
   Begin
     self.sFilter := '';
     btnFilter.Tag := 0;
     btnFilter.Text := sFilter;
     btnFilter.Bitmaps[0].BitmapName := 'FILTER_AUS';
     Daten_Laden('0');
     Exit;
   End;


end;

//====================================================================================================================//

procedure TfrmGetStammdaten.btnNavInfoClick(Sender: TObject);
var sID : String;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  Daten_Laden(sID);

end;

//====================================================================================================================//

procedure TfrmGetStammdaten.Daten_Laden( aID : String );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp, sPgr, sKopfZeile: String;
    aSL : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i : Integer;
    aArray : TArray<string>;
    aFzgObj : TCoreFzgObj;
    aItem : TResponsiveGridItem;
begin

  btnNavInfo.Enabled := False;

console.log('-1 ' );



  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  Case self.iTabelle Of
      c_Fzg : Begin
                sSQL := 'SELECT ID_FAHRZEUG, KENNZEICHEN, NUMMER FROM FAHRZEUG F, FAHRZEUG_TYP T'
                               +' WHERE F.ID_FAHRZEUG_TYP=T.ID_FAHRZEUG_TYP  '
                               +' AND STATUS IN (10,20) ';
                If self.iEigenAntrieb=1 then sSQL := sSQL + ' AND IIF(EIGEN_ANTRIEB IS NULL,0,EIGEN_ANTRIEB)=1 ';
                If self.iEigenAntrieb=2 then sSQL := sSQL + ' AND IIF(EIGEN_ANTRIEB IS NULL,0,EIGEN_ANTRIEB)=0 ';
                If sFilter<>'' then sSQL := sSQL + '  AND Upper(F.KENNZEICHEN) LIKE '+cH+'%'+AnsiUpperCase(sFilter) +'%'+cH;
                sSQL := sSQL  +' ORDER BY KENNZEICHEN ';
              End;
      c_Teil : Begin
                // Produktgruppe ermitteln
                sPgr := '';
                sSQL := 'SELECT WERT FROM OPTIONEN WHERE BEREICH='+cH+'MOBIL'+cH +' AND FELD='+cH+'ID_TEILEBENE1'+cH;
                sSQL := await(  Crypt( sSQL )  );
                Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDaten', [ sSQL, 0, 0 ] ) );
                Blob := Response.Result;
                asm sDaten = await Blob.text(); end;
                sDaten := await( Crypt( sDaten ));
                aSL.Text := sDaten;
                sTmp := aSL[2];
                aArray := sTmp.Split([';']);
                sPgr := aArray[0];
                sSQL := 'SELECT ID_TEIL, BEZEICHNUNG FROM TEIL WHERE ID_TEILEBENE1='+cH+sPgr+cH;
       console.log(ssql) ;
       console.log(sPgr) ;
              End;
  End;

  sSQL := await(  Crypt( sSQL )  );

  Response := await( ClientConn.RawInvokeAsync('ISystemService.GetDaten', [ sSQL, iRec_Von,iRec_Bis] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;

  ClientConn.Free;

  aSL.Text := await( Crypt( sDaten));

  sKopfZeile := aSL[0];
  aArray := sKopfZeile.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';

  If self.iTabelle = c_Fzg then //------------------------------------------------------------
     Begin
        respGrid.Items.Clear;
        For i := 2 to aSL.Count -1 Do
          Begin
            sTmp := aSL[i];
            aArray := sTmp.Split([';']);
            sTmp := aArray[1];
            aItem := respGrid.Items.Add;
            aItem.HTML := sTmp;
            aItem.Tag :=  StrToIntDef( aArray[0], 0);
          End;
     End;

  If self.iTabelle = c_Teil then //------------------------------------------------------------
     Begin
        respGrid.Items.Clear;
        For i := 2 to aSL.Count -1 Do
          Begin
            sTmp := aSL[i];
            aArray := sTmp.Split([';']);
            sTmp := aArray[1];
            aItem := respGrid.Items.Add;
            aItem.HTML := sTmp;
            aItem.Tag :=  StrToIntDef( aArray[0], 0);
          End;
     End;



  If self.iTabelle = c_ZM then //------------------------------------------------------------
     Begin
        tabZeitmodelle.Close;
        tabZeitmodelle.Open;
        For i := 2 to aSL.Count -1 Do
            Begin
             sTmp := aSL[i];
              aArray := sTmp.Split([';']);
              tabZeitmodelle.Append;
              tabZeitmodelle.FieldByName('WMOD_NUMMER').AsInteger := StrToIntDef(aArray[0],0);
              tabZeitmodelle.FieldByName('WMOD_NAME').AsString    := aArray[1];
              tabZeitmodelle.Post;
            End;
        If aID = '' then tabZeitmodelle.First;
        If aID > '' then
          If not tabZeitmodelle.Locate('WMOD_NUMMER',aID,[]) then tabZeitmodelle.First;
        btnNavNext.Enabled := (tabZeitmodelle.RecordCount=frmMainForm.g_RecAnzahl );
     End;

  aSL.Free;

  btnNavInfo.Enabled := True;

  WaitMessage.Hide;

end;


//====================================================================================================================//

procedure TfrmGetStammdaten.Do_DatenLaden(Sender: TObject);
begin


  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden('');

end;

//====================================================================================================================//

procedure TfrmGetStammdaten.WebFormCreate(Sender: TObject);
begin

  sFilter := '';

  bFirst := False;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;

end;

procedure TfrmGetStammdaten.WebFormResize(Sender: TObject);
begin
  Form_Anpassen;
end;

//====================================================================================================================//

procedure TfrmGetStammdaten.WebFormShow(Sender: TObject);
begin

  Case self.iTabelle Of
    c_Fzg : Begin
             lbSelTabelle.Caption := 'Fahrzeug wählen ' ;
             respGrid.Options.ItemWidthMin := 120;
            End;
    c_Teil: Begin
             lbSelTabelle.Caption := 'Artikel wählen ' ;
             respGrid.Options.ItemWidthMin := 200;
            End;
  End;

  WaitMessage.PictureURL := frmMainForm.g_WaitGifURL;
  WaitMessage.Show;

  Daten_Laden('');

end;

//====================================================================================================================//

procedure TfrmGetStammdaten.WebPanel3Click(Sender: TObject);
begin

end;


//====================================================================================================================//

procedure TfrmGetStammdaten.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;


//  // Komponenten
//   iZielBreite := Trunc( self.Width * 0.95 );
//   If iZielBreite > 500 then iZielBreite := 500;
//
//   cbxDokumente.Width := iZielBreite - cbxDokumente.Left;
//
//   fpFilePicker.Width := iZielBreite - fpFilePicker.Left;
//   edtBeginn.Width  := iZielBreite - edtBeginn.Left;
//   edtEnde.Width := iZielBreite - edtEnde.Left;
//
//   sigCapt.Width := iZielBreite - sigCapt.Left;
//   btnSignaturSpeichern.Width := iZielBreite - btnSignaturSpeichern.Left;
//   mInfoSign.Width := iZielBreite - mInfoSign.Left;
//
//   Console.Log('>> Form_Anpassen');
//   lbDokumentPos.Left := cbxDokumente.Left + cbxDokumente.Width - lbDokumentPos.Width;

end;

procedure TfrmGetStammdaten.respGridItemClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;
    aID : Integer;
begin
  inherited;

  aItem := respGrid.Items[Index] ;
  aID := aItem.Tag;


  Case self.iTabelle Of
    c_Fzg : Begin
              self.iSel_ID :=  aID;
              self.SSel_Bez := aItem.HTML;
            End;
    c_Teil : Begin
              self.iSel_ID :=  aID;
              self.SSel_Bez := aItem.HTML;
            End;
  End;

  ModalResult := mrOK;
  Close

end;

//====================================================================================================================//

procedure TfrmGetStammdaten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbSelTabelle := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  btnFilter := TTMSFNCToolBarButton.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  tabZeitmodelle := TXDataWebDataSet.Create(Self);
  tabZeitmodelleWMOD_NUMMER := TStringField.Create(Self);
  tabZeitmodelleWMOD_NAME := TStringField.Create(Self);
  dsZeitmodelle := TDataSource.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbSelTabelle.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  btnFilter.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabZeitmodelle.BeforeLoadDFMValues;
  tabZeitmodelleWMOD_NUMMER.BeforeLoadDFMValues;
  tabZeitmodelleWMOD_NAME.BeforeLoadDFMValues;
  dsZeitmodelle.BeforeLoadDFMValues;
  try
    Width := 393;
    Height := 633;
    Hint := 'zur'#252'ck';
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WaitMessage.Left := 467;
    WaitMessage.Top := 108;
    BitmapCont.Left := 385;
    BitmapCont.Top := 106;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 393;
    WebPanel1.Height := 80;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 1;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 0;
    lbSelTabelle.SetParentComponent(WebPanel1);
    lbSelTabelle.Name := 'lbSelTabelle';
    lbSelTabelle.Left := 10;
    lbSelTabelle.Top := 3;
    lbSelTabelle.Width := 88;
    lbSelTabelle.Height := 18;
    lbSelTabelle.Caption := '....w'#228'hlen';
    lbSelTabelle.Font.Charset := ANSI_CHARSET;
    lbSelTabelle.Font.Color := clBlack;
    lbSelTabelle.Font.Height := -16;
    lbSelTabelle.Font.Name := 'Verdana';
    lbSelTabelle.Font.Style := [fsBold];
    lbSelTabelle.HeightPercent := 100.000000000000000000;
    lbSelTabelle.ParentFont := False;
    lbSelTabelle.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 75;
    btnNavPrev.Top := 30;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.TextVisible := False;
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 249;
    btnNavNext.Top := 30;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.TextVisible := False;
    btnNavNext.StretchBitmapIfNoText := False;
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 141;
    btnNavInfo.Top := 30;
    btnNavInfo.Width := 106;
    btnNavInfo.Height := 44;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 4;
    btnAbbrechen.Top := 30;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 3;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnAbbrechenClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    btnFilter.SetParentComponent(WebPanel1);
    btnFilter.Name := 'btnFilter';
    btnFilter.Left := 320;
    btnFilter.Top := 30;
    btnFilter.Width := 65;
    btnFilter.Height := 44;
    btnFilter.Cursor := crHandPoint;
    btnFilter.ParentDoubleBuffered := False;
    btnFilter.DoubleBuffered := True;
    btnFilter.Font.Charset := DEFAULT_CHARSET;
    btnFilter.Font.Color := clWindowText;
    btnFilter.Font.Height := -11;
    btnFilter.Font.Name := 'Segoe UI';
    btnFilter.Font.Style := [];
    btnFilter.ParentColor := True;
    btnFilter.TabOrder := 4;
    SetEvent(btnFilter, Self, 'OnClick', 'btnFilterClick');
    btnFilter.Text := '';
    btnFilter.StretchBitmapIfNoText := False;
    btnFilter.Bitmaps.Clear;
    with btnFilter.Bitmaps.Add do
    begin
      Bitmap.LoadFromFile('GetStammdaten.btnFilter.Bitmaps.Bitmap.png');
      BitmapName := 'FILTER_EIN';
    end;
    btnFilter.BitmapPosition := bbpTop;
    btnFilter.BitmapVisible := True;
    btnFilter.ControlIndex := 0;
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 80;
    respGrid.Width := 393;
    respGrid.Height := 553;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 30;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 10;
    respGrid.Options.ItemWidthMin := 120;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemClick');
    tabSprachDaten.Left := 136;
    tabSprachDaten.Top := 256;
    tabZeitmodelle.SetParentComponent(Self);
    tabZeitmodelle.Name := 'tabZeitmodelle';
    tabZeitmodelle.Left := 88;
    tabZeitmodelle.Top := 176;
    tabZeitmodelleWMOD_NUMMER.SetParentComponent(tabZeitmodelle);
    tabZeitmodelleWMOD_NUMMER.Name := 'tabZeitmodelleWMOD_NUMMER';
    tabZeitmodelleWMOD_NUMMER.FieldName := 'WMOD_NUMMER';
    tabZeitmodelleWMOD_NUMMER.Size := 5;
    tabZeitmodelleWMOD_NAME.SetParentComponent(tabZeitmodelle);
    tabZeitmodelleWMOD_NAME.Name := 'tabZeitmodelleWMOD_NAME';
    tabZeitmodelleWMOD_NAME.FieldName := 'WMOD_NAME';
    tabZeitmodelleWMOD_NAME.Size := 100;
    dsZeitmodelle.SetParentComponent(Self);
    dsZeitmodelle.Name := 'dsZeitmodelle';
    dsZeitmodelle.DataSet := tabZeitmodelle;
    dsZeitmodelle.Left := 176;
    dsZeitmodelle.Top := 176;
  finally
    WaitMessage.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbSelTabelle.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    btnFilter.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabZeitmodelle.AfterLoadDFMValues;
    tabZeitmodelleWMOD_NUMMER.AfterLoadDFMValues;
    tabZeitmodelleWMOD_NAME.AfterLoadDFMValues;
    dsZeitmodelle.AfterLoadDFMValues;
  end;
end;

end.